import { PageHeader, Icon, Button } from "@evertrue/et-components";
import { useIdentity } from "base/identity-resolver";
import Resources from "./resources";
import Metrics from "./metrics";

import Upcoming from "./upcoming";
import RecommendedActions from "./recommended-actions/recommended-actions";
import { RecommendedActionsProvider } from "./recommended-actions/context/recommended-actions-context";

const HomepageMainContent = () => {
  const { user } = useIdentity();
  const userName = user.name.split(" ")[0];
  return (
    <>
      <div className="homepage-title-containter">
        <PageHeader title={`Welcome, ${userName}!`} className="homepage-title" />
      </div>
      <div className="homepage-settings-container">
        <Button type="simple" href="settings">
          <Icon icon="gear" size={1} className="homepage-settings-icon" />
        </Button>
      </div>
      <div className="homepage-main-content">
        <Upcoming />
        <RecommendedActionsProvider>
          <RecommendedActions />
        </RecommendedActionsProvider>
        <Metrics />
        <Resources />
      </div>
    </>
  );
};
export default HomepageMainContent;
